import { render } from "./AttachmentRichText.vue?vue&type=template&id=d4233cb6&scoped=true"
import script from "./AttachmentRichText.vue?vue&type=script&lang=js"
export * from "./AttachmentRichText.vue?vue&type=script&lang=js"

import "./AttachmentRichText.vue?vue&type=style&index=0&id=d4233cb6&lang=scss&scoped=true"
import "./AttachmentRichText.vue?vue&type=style&index=1&id=d4233cb6&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4233cb6"]])

export default __exports__